// extracted by mini-css-extract-plugin
export default {"container":"action_container__0NOTG","rate":"action_rate__mWuVT","chat":"action_chat__kEJba"};